import React from 'react';

const CraBakeryTaxFields = ({ value, onChange }) => {
  const update = (field, fieldValue) => {
    onChange({ [field]: fieldValue });
  };

  return (
    <section className="space-y-6 rounded-2xl border border-amber-100 bg-amber-50/50 p-6">
      <div>
        <h4 className="text-sm font-black uppercase tracking-widest text-amber-800">
          CRA Bakery Tax Details
        </h4>
        <p className="mt-2 text-xs leading-relaxed text-slate-500">
          Review these details for the applicable tax classification of this item.
        </p>
      </div>

      <div>
        <label className="mb-2 block text-[10px] font-black uppercase tracking-widest text-slate-500">
          Tax classification
        </label>
        <input
          type="text"
          value={value.cra_bakery_tax_classification || ''}
          onChange={(event) => update('cra_bakery_tax_classification', event.target.value)}
          className="w-full rounded-xl border border-amber-100 bg-white px-4 py-3 text-sm font-medium outline-none focus:ring-2 focus:ring-amber-300"
          placeholder="needs_review"
        />
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <label className="flex items-center gap-3 text-sm font-medium text-slate-700">
          <input
            type="number"
            min="1"
            value={value.cra_servings_per_unit ?? 1}
            onChange={(event) => update('cra_servings_per_unit', event.target.value)}
            className="w-24 rounded-xl border border-amber-100 bg-white px-3 py-2 outline-none focus:ring-2 focus:ring-amber-300"
          />
          Servings per unit
        </label>

        <label className="flex items-center gap-3 text-sm font-medium text-slate-700">
          <input
            type="checkbox"
            checked={Boolean(value.cra_qualifying_packaging)}
            onChange={(event) => update('cra_qualifying_packaging', event.target.checked)}
            className="h-4 w-4 accent-amber-600"
          />
          Qualifying packaging
        </label>

        <label className="flex items-center gap-3 text-sm font-medium text-slate-700">
          <input
            type="number"
            min="0"
            value={value.cra_cake_weight_grams ?? ''}
            onChange={(event) => update('cra_cake_weight_grams', event.target.value)}
            className="w-24 rounded-xl border border-amber-100 bg-white px-3 py-2 outline-none focus:ring-2 focus:ring-amber-300"
            placeholder="—"
          />
          Cake weight (g)
        </label>

        <label className="flex items-center gap-3 text-sm font-medium text-slate-700">
          <input
            type="checkbox"
            checked={Boolean(value.cra_cake_customized)}
            onChange={(event) => update('cra_cake_customized', event.target.checked)}
            className="h-4 w-4 accent-amber-600"
          />
          Customized cake
        </label>

        <label className="flex items-center gap-3 text-sm font-medium text-slate-700 sm:col-span-2">
          <input
            type="checkbox"
            checked={Boolean(value.cra_cake_individually_qualifies)}
            onChange={(event) => update('cra_cake_individually_qualifies', event.target.checked)}
            className="h-4 w-4 accent-amber-600"
          />
          Cake individually qualifies
        </label>
      </div>

      <div>
        <label className="mb-2 block text-[10px] font-black uppercase tracking-widest text-slate-500">
          Tax review note
        </label>
        <textarea
          rows="2"
          value={value.cra_tax_review_note || ''}
          onChange={(event) => update('cra_tax_review_note', event.target.value)}
          className="w-full rounded-xl border border-amber-100 bg-white px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-amber-300"
          placeholder="Add any notes for tax review..."
        />
      </div>
    </section>
  );
};

export default CraBakeryTaxFields;
